import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { applyGeographicalDivision } from "@icarius-table/utils";
import { getColumnDefByPage } from "@icarius-table/columnDefs";
import CommonPage from "@icarius-common/commonPage";
import { getGeographicalDivisions } from "@icarius-app/selectors";

const GridData = (props) => {
    const { data, dateFormat, locale, path, isNPS, isOnboarding, isONA } = props;

    const geographicalDivisions = useSelector(getGeographicalDivisions);

    const ownColumnDef = useMemo(() => {
        let auxOwnColumnDef = applyGeographicalDivision(getColumnDefByPage(path), geographicalDivisions);

        const answerColumn = auxOwnColumnDef.find((item) => item.field === "RESPUESTA");
        answerColumn.headerName = isNPS ? "NPS" : getLocalizedString("answer");

        if (isOnboarding) {
            const onboardingProcessColumn = {
                headerName: getLocalizedString("onboardingProcess"),
                field: "PROCESO DE ONBOARDING",
                filter: "agSetColumnFilter",
            };
            auxOwnColumnDef.splice(2, 0, onboardingProcessColumn);
        }

        if (isONA) {
            const onaDestinataryColumn = {
                headerName: getLocalizedString("onaDestinatary"),
                field: "DESTINATARIO",
                filter: "agSetColumnFilter",
            };
            auxOwnColumnDef.splice(4, 0, onaDestinataryColumn);
            auxOwnColumnDef = auxOwnColumnDef.filter((column) => column.field !== "VOTOS");
        }

        return auxOwnColumnDef;
    }, [isNPS, isOnboarding, isONA, path, geographicalDivisions]);

    return (
        <div style={{ marginBottom: 30 }}>
            <CommonPage
                gridTitle={getLocalizedString("pollReview")}
                ownColumnDef={ownColumnDef}
                rowData={data}
                dateFormat={dateFormat}
                locale={locale}
                gridHeight={500}
                hasSelectAll
                hasExpand
            />
        </div>
    );
};

export default GridData;
